<template>
  <v-container>
    <h1>Error in authentication</h1>
  </v-container>
</template>

<script>
export default {
  name: 'OidcCallbackError'
}
</script>